import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { MaterialCountingHorizontalBarChart } from "../../../components/charts/MaterialCountingHorizontalBarChart";

const QualityPieChartSection = ({
  title,
  subtitle,
  fluxesList,
  selectedFlux,
  setSelectedFlux,
  values,
  labels,
  colorSet,
  total,
  slotCount = 0,
  t,
  chartPlotRef,
  forceSelectedFlux = null,
}) => {
  const { i18n } = useTranslation();
  const formattedTotal = Number(total || 0).toLocaleString(i18n.language);
  const totalLabel =
    total > 1 ? t("Detected materials") : t("Detected material");

  useEffect(() => {
    if (!forceSelectedFlux || !setSelectedFlux) return;
    const match = (fluxesList || []).find(
      (flux) =>
        flux.label === forceSelectedFlux || flux.id === forceSelectedFlux,
    );
    if (match && selectedFlux !== match.label) {
      setSelectedFlux(match.label);
    }
  }, [forceSelectedFlux, fluxesList, selectedFlux, setSelectedFlux]);

  return (
    <article className="statistics-card min-lg:min-w-0 flex flex-col h-full">
      <div className="dashboard-chart-heading dashboard-chart-heading-row flex-shrink-0 min-h-[72px]">
        <div className="dashboard-chart-heading-text">
          <h5 className="dashboard-chart-title">{title}</h5>
          {subtitle ? (
            <p className="dashboard-chart-subtitle">{subtitle}</p>
          ) : null}
        </div>

        <div className="flex items-center gap-1 px-3 py-1.5 rounded-full border border-[#E5E5E5] text-sm whitespace-nowrap flex-shrink-0">
          <span className="text-gray-500">{t("Flux")} :</span>
          <select
            value={selectedFlux}
            onChange={(event) => setSelectedFlux(event.target.value)}
            className="bg-transparent font-semibold text-[#000000] focus:outline-none cursor-pointer max-w-[140px]"
          >
            {fluxesList.map((flux) => (
              <option key={flux.id} value={flux.label}>
                {flux.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="flex items-center gap-2 mb-3 flex-shrink-0 w-fit rounded-full bg-[#E9FBFB] px-3 py-1.5">
        <span className="text-sm text-[#008685]">{totalLabel}</span>
        <span className="text-base font-bold text-[#008685] tabular-nums">
          {formattedTotal}
        </span>
      </div>

      <div className="w-full min-h-[240px]" ref={chartPlotRef}>
        <MaterialCountingHorizontalBarChart
          dataChart={values}
          labelChart={labels}
          materialTotal={total}
          colorChart={colorSet}
          showMaterialTotal={false}
          slotCount={slotCount}
        />
      </div>
    </article>
  );
};

export default QualityPieChartSection;
